module.exports = __webpack_public_path__ + "fonts/chosen-sprite@2x.cb0d09c93b99c5cab6848147fdb3d7e4.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/forms/chosen-sprite@2x.png
// module id = 263
// module chunks = 9